<template>
  <bita-modal
    :id="modalId"
    :title="title"
    :modal-lg="true"
    :isLoading="isLoading"
    @close="onCloseModal"
  >
    <div slot="body">
      <div class="row" v-if="$acl.can('view', 'admin-of-sellers')">
        <div class="col-6">
          نام و نام خانوادگی:
          {{ formItems.full_name ? formItems.full_name : "-" }}
        </div>
        <div class="col-6">
          زمان ثبت سفارش:
          {{
            formItems.created_at
              ? $getJalaliDateTime(formItems.created_at)
              : "-"
          }}
        </div>
      </div>
      <div class="row" v-if="$acl.can('view', 'admin-of-sellers')">
        <div class="col-6">
          استان: {{ formItems.province ? formItems.province : "-" }}
        </div>
        <div class="col-6">
          شهر: {{ formItems.city ? formItems.city : "-" }}
        </div>
      </div>
      <div class="row" v-if="$acl.can('view', 'admin-of-sellers')">
        <div class="col-6">
          ادرس: {{ formItems.address ? formItems.address : "-" }}
        </div>
        <div class="col-6">
          کدپستی: {{ formItems.postal_code ? formItems.postal_code : "-" }}
        </div>
      </div>
      <div class="row" v-if="$acl.can('view', 'admin-of-sellers')">
        <div class="col-6">
          تلفن همراه: {{ formItems.mobile ? formItems.mobile : "-" }}
        </div>
        <div class="col-6">
          تلفن ثابت: {{ formItems.tel ? formItems.tel : "-" }}
        </div>
        
      </div>
      <div class="row" v-if="$acl.can('view', 'admin-of-sellers')">
        <div class="col-6">
          ایمیل: {{ formItems.email ? formItems.email : "-" }}
        </div>
      </div>
      <br />
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>#</th>
            <th>کد</th>
            <th>نام</th>
            <th>فروشنده</th>
            <th>تعداد</th>
            <th>قیمت واحد</th>
            <th>مبلغ کل</th>
            <th>مبلغ تخفیف</th>
            <th>مبلغ کل پس از تخفیف</th>
            <!-- <th>قیمت با تخفیف</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in formItems.items" :key="index">
            <td>{{ index + 1 }}</td>
            <td>{{ item.product_price ? item.product_price.code : "-" }}</td>
            <td>{{ item.product.name }} <br/> <small>{{ item.combination_text }}</small></td>
            <td>{{ item.seller.seller_store_name }}</td>
            <td>{{ item.count }}</td>
            <td>{{ $thousandSeprator(item.price) }}</td>
            <td>{{ $thousandSeprator(item.price * item.count) }}</td>
            <td>{{ $thousandSeprator(item.payable_price - item.price) }}</td>
            <td>{{ $thousandSeprator(item.payable_price * item.count) }}</td>
          </tr>
          <tr>
            <td  v-if="$acl.can('view', 'admin-of-sellers')" colspan="7" style="text-align: left">جمع کل</td>
            <td v-if="$acl.can('view', 'admin-of-sellers')" colspan="7">{{ $thousandSeprator(formItems.total) }}</td>
          </tr>
          <tr v-if="$acl.can('view', 'admin-of-sellers')">
            <td colspan="7" style="text-align: left">هزینه حمل</td>
            <td colspan="7">
              {{ $thousandSeprator(formItems.shipping_price) }}
            </td>
          </tr>
          <tr v-if="$acl.can('view', 'admin-of-sellers')">
            <td colspan="7" style="text-align: left">تخفیف</td>
            <td colspan="7">{{ $thousandSeprator(formItems.discount) }}</td>
          </tr>
          <tr v-if="$acl.can('view', 'admin-of-sellers')">
            <td colspan="7" style="text-align: left">قابل پرداخت</td>
            <td colspan="7">{{ $thousandSeprator(formItems.payable) }}</td>
          </tr>
          <tr v-if="$acl.can('view', 'admin-of-sellers')">
            <td colspan="7" style="text-align: left">پرداخت شده</td>
            <td colspan="7">{{ $thousandSeprator(formItems.payed) }}</td>
          </tr>
          <tr v-if="$acl.can('view', 'admin-of-sellers')">
            <td colspan="7" style="text-align: left">مانده</td>
            <td colspan="7">{{ $thousandSeprator(formItems.payable - formItems.payed) }}</td>
          </tr>
        </tbody>
      </table>
      <bita-form ref="form" v-if="$acl.can('view', 'admin-of-sellers')">
        <div slot="body">
          <div class="row">
            <bita-select
              name="status"
              label="وضعیت"
              ref="statusDropDown"
              rules="required"
              validation-container-class="col-lg-3 col-md-6 col-sm-6"
              input-class="form-control"
              :data-source="statuses"
              data-text-field="title"
              data-value-field="id"
              v-model="formItems.status"
            />
            <bita-input
              type="text"
              name="tonnage"
              label="پیگیری پست"
              rules=""
              validation-container-class="col-lg-3 col-md-6 col-sm-6"
              input-class="form-control"
              v-model="formItems.shipping_tracking_code"
            />
          </div>
          <div class="row">
            <bita-bootbutton
              v-if="formItems.paymethod && formItems.paymethod.method == 2"
              type="primary mr-2 ml-2"
              title="نمایش فیش"
              icon="fa fa-images"
              btn-width="200px"
              @click.native="showFullSizeImage"
            />
            <bita-bootbutton
              v-if="formItems.payment_status != 1"
              type="primary mr-2 ml-2"
              title="تایید پرداخت موفق"
              icon="fa fa-check"
              btn-width="200px"
              @click.native="paymentSuccessfully"
            />
          </div>
        </div>
      </bita-form>

      <div class="row my-3 mt-5" v-if="$acl.can('view', 'admin-of-sellers')">
        <div class="col-lg-auto">
          <input
            type="file"
            id="file"
            ref="file"
            v-on:change="handleFileUpload()"
          />
        </div>

        <div class="col-lg-auto">
          <bita-bootbutton
            type="primary"
            title="ذخیره"
            icon="fas fa-save"
            btn-width="150px"
            @click.native="save"
          />
        </div>

        <div id="photos">
          <div class="photo" v-for="(image, index) in receiptImages" :key="index">
            <span class="delete-image" 
              @click="deleteReceiptImagesOfOrder(image.id)">
              <i class="fas fa-times-circle"></i>
            </span>
            <a
              @click="downloadFile(image.id, image.mime_type)"
              style="    font-size: xxx-large;margin: 16px; margin-bottom: 5px;">
              <i class="fas fa-download"></i>
            </a>
            <p class="documentname"> عکس شماره {{index+=1}}  </p>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" v-if="$acl.can('view', 'admin-of-sellers')">
      <bita-bootbutton
        v-if="$acl.can('edit', 'orders')"
        type="primary"
        title="ذخیره"
        icon="fa fa-check"
        btn-width="150px"
        @click.native="handleSubmit()"
      />
      <bita-bootbutton
        class="mr-2"
        type="primary"
        title="چاپ لیبل پست"
        icon="fa fa-print"
        btn-width="150px"
        @click.native="labelPrint()"
      />
      <bita-bootbutton
        class="mr-2"
        type="primary"
        title="چاپ فاکتور"
        icon="fa fa-print"
        btn-width="150px"
        @click.native="printInvoice()"
      />
      <bita-bootbutton
        class="mr-2"
        type="danger"
        title="بستن"
        icon="fas fa-times"
        btn-width="150px"
        data-dismiss="modal"
      />
    </div>
  </bita-modal>
</template>
<script>
import { orderApi, settingApi } from "@/api/apiManagement";

export default {
  props: {
    modalId: {},
    isLoading: {},
    title: {},
    onSubmit: {},
  },
  data() {
    return {
      colWidth: "col-lg-4 col-md-6 col-sm-6",
      formItems: {},
      dataForm: {},
      statuses: [],
      formData: {
        file: "",
      },
      receiptImages: [],
      whatsappsupport: "",
    };
  },
  computed: {},
  mounted() {
    this.getStatuses();
    this.getSettings();
  },
  methods: {
    getSettings() {
      settingApi.getSettings().then(({ data }) => {
        this.whatsappsupport = data.entity[0].children.find(item => item.slug === "whatsappsupport")?.value || "";
      });      
    },
    setInitialData(_data) {
      this.receiptImages = [];
      // this.formItems = _data;
      orderApi.findOrder(_data.id).then(res => {
        this.formItems = res.data
        if (this.$acl.can("view", "admin-of-sellers")){
          this.getReceiptImagesOfOrder(); 
        }
      })
      .finally(() => {  })
    },

    handleFileUpload() {
      this.formData.file = this.$refs.file.files[0];
    },

    save(formData) {
      this.isLoadingModal = true;
      orderApi
        .createOrderReceipt(this.formItems.id, this.getFormData(this.formData))
        .then((res) => {
          this.$izitoast("success", "موفق!", res.data.message);
          this.getReceiptImagesOfOrder(); 
          this.formData.file = "";
        })
        .finally(() => {
          this.isLoadingModal = false;
        });
    },

    getFormData() {
      let formData = new FormData();
      for (var key in this.formData) {
        if (this.formData[key] != null) {
          formData.append(key, this.formData[key]);
        }
      }
      return formData;
    },

    getReceiptImagesOfOrder() {
      orderApi.getReceiptImagesOfOrder(this.formItems.id).then(({ data }) => {
        this.receiptImages = data.entity;
      });
    },

    downloadFile(file_id,doc_type) {
      
      const result=doc_type.split("/");
       let type=result[1];
        axios({
                url: `/shop/orders/receipt/download?file_id=${file_id}`, 
                method: 'GET',
                responseType: 'blob'
            }).then((res) => {
                var FILE = window.URL.createObjectURL(new Blob([res.data]));
                var docUrl = document.createElement('a');
                var random = Math.random()
                docUrl.href = FILE;
                docUrl.setAttribute('download', random+  '.' + type);
                document.body.appendChild(docUrl);
                docUrl.click();
            });
    },


    deleteReceiptImagesOfOrder: function (fileId) {

        let question = "آیا از حذف تصویر اطمینان دارید؟";

        this.$alert("question", question, null, {
          confirmButtonText: "بله",
        }).then((result) => {
          if (result.value) {
            this.$emit("is-loading", true);
            orderApi
              .deleteReceiptImagesOfOrder(fileId)
              .then((res) => {
                this.getReceiptImagesOfOrder()
                this.$izitoast("success", "عملیات موفق", res.data.message);
              })
              .finally(() => {
                this.$emit("is-loading", false);
              });
          }
        });
    },

    getStatuses() {
      orderApi.getStatuses().then(({ data }) => (this.statuses = data));
    },
    handleSubmit() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-submit", {
            form_data: this.formItems,
            id: this.formItems.id,
          });
        }
      });
    },
    printInvoice() {
      let baseUrl = process.env.VUE_APP_API_BASEPOINT;
      window.open(`orders/${this.formItems.id}/print`, "_blank");
    },
    printTemplate() {
      if (this.formItems) {
        let cities = `${this.formItems.province}، ${this.formItems.city}`;
        let address = this.formItems.address;
        let fullName = this.formItems.full_name;
        let tel = this.formItems.mobile;
        let postalcode = this.formItems.postal_code;
        var template = "";
        template += "<div>";
        template +=
          "<div style='direction:rtl; text-align=right;line-height: 25px; font-size:15px; font-weigth: bold; font-family: iranyekan' >";
        template +=
          '<h4 style="padding: 5px 0; margin: 5px 0;line-height:10px;">گیرنده: ' +
          cities +
          "</h4>";
        template += '<div style="width: 280px">' + address + "</div>";
        template += "<div> اقای/خانم" + " " + fullName + "</div>";
        template += "<div>تلفن: " + tel + "</div>";
        template += "<div>کدپستی: " + postalcode + "</div>";
        template += "</div>";
        template += "</div>";
        return template;
      }
    },
    reset() {
      this.$refs.form.reset();

      this.formItems = {};
    },

    labelPrint() {

      let imageUrl = require('@/assets/img/labelPrint/image.png');
      let estedadUrl = require('@/assets/fonts/estedad/woff2/Estedad-Regular.woff2');

      if (this.formItems) {
        var province = this.formItems.province;
        var city = this.formItems.city;
        var address = this.formItems.address;
        var fullName = this.formItems.full_name;
        var mobile = this.formItems.mobile ?? "";
        var tel = this.formItems.tel;
        var postalcode = this.formItems.postal_code;
      }

      let iframe = document.createElement("iframe");
      iframe.name = "myiframe";
      iframe.className = "printFrame";
      iframe.style.position = "absolute";
      iframe.style.top = "-1000px";
      iframe.style.left = "-1000px";
  
      document.body.appendChild(iframe);

      iframe.srcdoc = `
        <html>
          <head>
            <title>چاپ</title>
            <style>

              @font-face {
                font-family: 'Estedad';
                src: url('${estedadUrl}') format('woff2');
                font-weight: normal;
                font-style: normal;
              }

              body { text-align: right; line-height: 25px; font-family: Estedad; direction: rtl; margin: 20px 25px; font-weight: 700; }
            </style>
          </head>
          <body>
            <div class="center">

                <div style="text-align: center;">
                  <img src="${imageUrl}" style="width: 230px;" alt="عکس لیبل پرینت" >
                </div>
                
                <div style="font-size: 35px; font-weight: 700;">گیرنده:</div>

                <div style="margin-top: 45px; margin-bottom: 45px; font-size: 30px;">
                  نام و نام خانوادگی: ${fullName}
                </div>  

                <pre style="margin-top: 25px; font-family: Estedad; font-weight: 700; font-size: 30px; ">استان: ${province}                شهر: ${city}</pre>

                <div style="text-align: justify; line-height: 50px; margin-bottom: 30px; font-weight: 600; font-size: 30px;">
                  آدرس: ${address}
                </div>

                <div style="display: flex; justify-content: space-between; font-size: 30px; font-weight: 700;">
                    <div>موبایل:</div>
                    <div> ${mobile} </div>
                </div>

                <div style="display: flex; justify-content: space-between;  margin: 25px 0; font-size: 30px; font-weight: 700;">
                    <div>کدپستی:</div>
                    <div> ${postalcode} </div>
                </div>

                <div style="display: flex; justify-content: space-between; font-size: 30px; font-weight: 700;">
                    <div>تلفن ثابت:</div>
                    <div> ${tel} </div>
                </div>

                <div style="border: 3px solid black; margin: 20px 0;"></div>

                <div style="font-size: 35px; font-weight: 700; margin-top: 40px;">فرستنده:</div>

                <div style="font-size: 30px; font-weight: 700; text-align: center; margin-top: 30px;"> مرکز خرید عمده و خرده کوچه بازار </div>

                <div style="font-size: 23px; font-weight: 700; text-align: center; margin-top: 35px;"> ارسال از انبار شماره 3 </div>

                <div style="font-size: 30px; font-weight: 700; margin-top: 30px;">امور مشتریان:</div>

                <div style="display: flex; justify-content: space-between; font-size: 30px; font-weight: 700; margin-top: 35px;">
                  <div> 021-55983603 </div>
                  <div> ${this.whatsappsupport} </div>
                </div>
            </div>
          </body>
        </html>
      `;

      iframe.onload = () => {
        iframe.contentWindow.focus();
        iframe.contentWindow.print();
        setTimeout(() => {
          document.body.removeChild(iframe);
        }, 1000);
      };
    },


    // labelPrint() {
    //   $("<iframe>", {
    //     name: "myiframe",
    //     class: "printFrame",
    //   })
    //     .appendTo("body")
    //     .contents()
    //     .find("body")
    //     .append(this.printTemplate());

    //   window.frames["myiframe"].focus();
    //   window.frames["myiframe"].print();

    //   setTimeout(() => {
    //     $(".printFrame").remove();
    //   }, 1000);
    // },

    showFullSizeImage() {
      var url = this.formItems.receipt_file_url;
      window.open(url, "receipt image");
    },

    clearKendos(_refs) {
      for (let ref of _refs) {
        if (this.$refs[ref]) this.$refs[ref].emptyKendo();
      }
    },
    onCloseModal(e) {
      this.formItems = {};
      let dropDowns = ["statusDropDown"];
      this.clearKendos(dropDowns);
      this.reset();
    },
    paymentSuccessfully(e) {
      this.$emit("on-update", this.formItems);
    },
  },
};
</script>

<style scoped>
.photo {
  float: right;
  position: relative;
  margin: 0 10px 10px 0;
  padding: 5px;
  border: 2px darkblue solid;
  width: 110px;
  height: 110px;

}
.photo img {
  object-fit: contain;
  width: 200px;
  border: 1px solid #ccc;
  border-radius: 5px;
  /* height: 200px; */
  /* background-color: #ccc; */
}
.documentname {
  text-align: center;
}
.delete-image {
  color: red;
  position: absolute;
  right: 2px;
  top: 2px;
}
.delete-image:hover i {
  color: red;
}
#photos {
  margin-top: 30px;;
}
</style>